/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} _Field_TagsInputs */

const de__field_tags = /** @type {(inputs: _Field_TagsInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Art-Kategorie`)
};

/**

* @param {_Field_TagsInputs} inputs
* @param {{ locale?: "de" }} options
* @returns {LocalizedString}
*/
export const _field_tags = /** @type {((inputs?: _Field_TagsInputs, options?: { locale?: "de" }) => LocalizedString) & import('../runtime.js').MessageMetadata<_Field_TagsInputs, { locale?: "de" }, {}>} */ ((inputs = {}, options = {}) => {
	experimentalStaticLocale ?? options.locale ?? getLocale()
	return de__field_tags(inputs)
});